import { SAMessageType } from '@missionlabs/smartagent-chat-components-lib/dist/ChatMessage/chat-message.types';
import { MessageSources, SocialMediaPlatform } from './chat.utils';
import { DPAState } from 'store/contact/contact.state';
import { EditorState, } from 'draft-js';
import { SocialChatJsonMessage } from '@missionlabs/smartagent-service-chat/dist/types/socialChatJsonMessage';
export interface ChatState {
    connections: IChat[];
    quickReplies?: { [key: string]: IChatQuickReply[] };
    quickRepliesLoading: boolean;
    selectedChatId?: string;
}

export interface IChatQuickReply {
    id: string | number;
    children?: IChatQuickReply[];
    content?: string;
    text: string;
}

export type AttachmentLoadingState = "waiting" | "loading" | "done"

export interface IChatAttachmentFile {
    file: File;
    loadingState: AttachmentLoadingState
}

export interface IChat {
    id: string;
    initialContactId: string
    status: connect.ContactStateType;
    acw: boolean;
    acwStartedAt: number | null;
    acwExtendedAt: number | null;
    queueName: string;
    isTyping: boolean;
    started: number;
    customerName: string;
    customerEmail?: string;
    lastMessage?: number;
    messages: Array<IChatMessage>;
    unread: number;
    reply: {
        text: string;
        isProbablyJson: boolean;
    };
    channel?: MessageSources;
    DPA?: DPAState;
    'sa-acw-notes'?: string;
    'sa-notes'?: string;
    currentEditorContent: EditorState;
    attachments: {
        files: IChatAttachmentFile[],
    }
    socialMediaPlatform?: SocialMediaPlatform;
    customerActive?: boolean
    sourceMessage?: SourceMessage;
    translationLanguage?: string;
}

interface SourceMessage {
    content: string;
    timestamp: number;
    link: string;
}

export interface IChatMessage extends connect.ChatTranscriptItem {
    content: string | SAMessageType;
    readTimestamp?:string;
    deliveredTimestamp?: string;
}

export interface ISocialChatMessage extends connect.ChatTranscriptItem {
    content: string | SocialChatJsonMessage;
}

export enum ChatMessageEvent {
    TYPING = 'application/vnd.amazonaws.connect.event.typing',
    CONNECTION_ACKNOWLEDGED = 'application/vnd.amazonaws.connect.event.connection.acknowledged',
    MESSAGE_DELIVERED = 'application/vnd.amazonaws.connect.event.message.delivered',
    MESSAGE_READ = 'application/vnd.amazonaws.connect.event.message.read',
}